import { createActionGroup, emptyProps } from '@ngrx/store';

export const ProceedButtonActions = createActionGroup({
  source: 'Booking Proceed Button',
  events: {
    Display: emptyProps(),
    Hide: emptyProps(),
  },
});
